import React, { useState } from "react";
import "./AdminLogin.css";
import { ToastContainer, toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css"; // Import Toast CSS
import { FiEye, FiEyeOff } from "react-icons/fi"; // Eye Icons for Password Visibility
import { useNavigate } from "react-router-dom"; // Correct navigation method
import loginimg from "../Assests/img9.jpg";

const AdminLogin = () => {
  const navigate = useNavigate(); // ✅ Use React Router for navigation

  // ✅ Admin Credentials
  const adminCredentials = {
    username: "adminhospipharma",
    password: "admin@hospipharma052025",
  };

  // ✅ State for Login Form
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  // ✅ State for Password Visibility
  const [showPassword, setShowPassword] = useState(false);

  // ✅ Handle Input Change
  const adminHandleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  // ✅ Handle Form Submission
  const handleAdminSubmit = (e) => {
    e.preventDefault();

    // ✅ Check if entered username and password match admin credentials
    if (
      credentials.username === adminCredentials.username &&
      credentials.password === adminCredentials.password
    ) {
      toast.success("Login Successful! Redirecting...", { autoClose: 2000 });

      // ✅ Store login status in LocalStorage
      localStorage.setItem("role", "admin"); // Store role

      setTimeout(() => {
        navigate("/admin-dashboard"); // ✅ Redirect to Admin Dashboard
      }, 2500);
    } else {
      toast.error("Invalid Username or Password!");
    }
  };

  return (
    <div className="Login-main">
      <div className="Login-container">
        {/* ✅ Left Side - Image */}
        <div className="Login-image-container">
          <img src={loginimg} alt="Login Illustration" />
        </div>

        {/* ✅ Right Side - Form */}
        <div className="Login-form-container">
          <h2 className="Login-heading">Admin Login</h2>

          {/* ✅ Admin Login Form */}
          <div className="admin-container">
            <form onSubmit={handleAdminSubmit} className="Login-details-form">
              {/* ✅ Username Field */}
              <div className="form-group">
                <label>Username:</label>
                <input
                  type="text"
                  name="username"
                  className="form-input"
                  placeholder="Enter Username"
                  value={credentials.username}
                  onChange={adminHandleChange}
                  required
                />
              </div>

              {/* ✅ Password Field with Eye Icon */}
              <div className="form-group">
                <label>Password:</label>
                <div className="password-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-input"
                    placeholder="Enter Password"
                    value={credentials.password}
                    onChange={adminHandleChange}
                    required
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
              </div>

              {/* ✅ Submit Button */}
              <button type="submit" className="login-button">
                Admin Login
              </button>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default AdminLogin;
